import React, { useState, useCallback } from 'react';
import Popover from '@mlb/react-patterns/v4/components/Popover/popover';
import { PopoverPlacement } from '@mlb/react-patterns/v4/components/Popover/popover.types';
import MediaLinksMenu from './components/MediaLinksMenu';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import { ButtonOverride } from './medialinks.style';

const {
    mlbGrey5
} = COLORS;

const POPOVER_BOTTOM = PopoverPlacement.BOTTOM;

const EMPTY_DEPS = [];
const POPOVER_OFFSET = [20, 10];

const MediaLinks = () => {
    const [isActive, setIsActive] = useState(false);

    const onOpen = useCallback((e) => {
        setIsActive(true);
    }, EMPTY_DEPS);

    const onClose = useCallback((e) => {
        setIsActive(false);
    }, EMPTY_DEPS);

    return (
        <Popover
            popoverOffset={POPOVER_OFFSET}
            popoverContent={<MediaLinksMenu />}
            placement={POPOVER_BOTTOM}
            showArrow={false}
            onClose={onClose}
            onOpen={onOpen}
        >
            <ButtonOverride
                iconName={'icon-menu'}
                ariaLabel={'audio links'}
                shape={'hollow-borderless'}
                iconColor={mlbGrey5}
                hasHover={true}
                iconSize={30}
                className={isActive ? 'btn-active' : ''}
            />
        </Popover>
    );
};

export default MediaLinks;
